module.exports = __webpack_public_path__ + "7c6d4337c157e1339f425fd5cdd0d6b3.svg";